import React, { useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import "../components/Table/Table.css";
import { useTranslation } from "react-i18next";


const StudentFeedback = () => {
    const { t } = useTranslation();

    return (
        <>
            <div className="px-2 px-md-4">
                <div className="my-4 col-12 d-flex justify-content-between align-items-center">
                    <h5 className="">{t("Student Feedback")}</h5>
                </div>

                <div className="row">
                    <div className="col-md-4">
                        <label className="form-label">
                            {t("Academic year")}
                            {<span style={{ color: "red" }}>*</span>}
                        </label>
                        <select
                            name="academic_year"
                            className="common-input form-select"
                            required
                        >
                            <option value="">Select session</option>
                            <option value="2022-2024">2022-2024</option>
                        </select>
                    </div>
                    <div className="col-md-8 d-flex justify-content-start mt-4">
                        <button type="submit" className="btn btn-primary me-2">
                            {t("Search")}
                        </button>
                        <button type="button" className="btn btn-secondary">
                            {t("Cancel")}
                        </button>
                    </div>
                </div>

                <div className="Table mb-4">
                    <TableContainer
                        component={Paper}
                        style={{ boxShadow: "0px 13px 20px 0px #80808029" }}
                        className="my-4"
                    >
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>{t("Sr. No.")}</TableCell>
                                    <TableCell align="left">{t("Feedback")}</TableCell>
                                    <TableCell align="left">{t("Remark")}</TableCell>
                                </TableRow>
                            </TableHead>
                        </Table>
                    </TableContainer>
                </div>
            </div>
        </>
    );
};

export default StudentFeedback;